import * as CONSTANTS from './digitalCorrespondanceTables.constants';
import { DigitalCorrespondanceTable } from '@models/index';

/** LOAD */
export function loadDigitalCorrespondanceTables() {
    return { type: CONSTANTS.DIGITAL_CORRESPONDANCE_TABLES_LOAD };
}

export function loadDigitalCorrespondanceTablesSuccess(data: DigitalCorrespondanceTable[]) {
    return { type: CONSTANTS.DIGITAL_CORRESPONDANCE_TABLES_LOAD_SUCCESS, payload: data };
}

export function loadDigitalCorrespondanceTablesError(error: any) {
    return { type: CONSTANTS.DIGITAL_CORRESPONDANCE_TABLES_LOAD_ERROR, payload: error };
}


/** ADD */
export function addDigitalCorrespondanceTable(target: DigitalCorrespondanceTable) {
    return { type: CONSTANTS.DIGITAL_CORRESPONDANCE_TABLE_ADD, payload: target };
}

export function addDigitalCorrespondanceTableSuccess(target: DigitalCorrespondanceTable) {
    return { type: CONSTANTS.DIGITAL_CORRESPONDANCE_TABLE_ADD_SUCCESS, payload: target };
}

export function addDigitalCorrespondanceTableError(error: any) {
    return { type: CONSTANTS.DIGITAL_CORRESPONDANCE_TABLE_ADD_ERROR, payload: error };
}

export function addDigitalCorrespondanceTables(targetDigitalCorrespondanceTables: DigitalCorrespondanceTable[]) {
    return { type: CONSTANTS.DIGITAL_CORRESPONDANCE_TABLES_ADD, payload: targetDigitalCorrespondanceTables };
}

export function addDigitalCorrespondanceTablesSuccess(targetDigitalCorrespondanceTables: DigitalCorrespondanceTable[]) {
    return { type: CONSTANTS.DIGITAL_CORRESPONDANCE_TABLES_ADD_SUCCESS, payload: targetDigitalCorrespondanceTables };
}

export function addDigitalCorrespondanceTablesError(error: any) {
    return { type: CONSTANTS.DIGITAL_CORRESPONDANCE_TABLES_ADD_ERROR, payload: error };
}


/** UPDATE */
export function updateDigitalCorrespondanceTable(target: DigitalCorrespondanceTable) {
    return { type: CONSTANTS.DIGITAL_CORRESPONDANCE_TABLE_UPDATE, payload: target };
}

export function updateDigitalCorrespondanceTableSuccess(target: DigitalCorrespondanceTable) {
    return { type: CONSTANTS.DIGITAL_CORRESPONDANCE_TABLE_UPDATE_SUCCESS, payload: target };
}

export function updateDigitalCorrespondanceTableError(error: any) {
    return { type: CONSTANTS.DIGITAL_CORRESPONDANCE_TABLE_UPDATE_ERROR, payload: error };
}

export function updateDigitalCorrespondanceTables(targetDigitalCorrespondanceTables: DigitalCorrespondanceTable[]) {
    return { type: CONSTANTS.DIGITAL_CORRESPONDANCE_TABLES_UPDATE, payload: targetDigitalCorrespondanceTables };
}

export function updateDigitalCorrespondanceTablesSuccess(targetDigitalCorrespondanceTables: DigitalCorrespondanceTable[]) {
    return { type: CONSTANTS.DIGITAL_CORRESPONDANCE_TABLES_UPDATE_SUCCESS, payload: targetDigitalCorrespondanceTables };
}

export function updateDigitalCorrespondanceTablesError(error: any) {
    return { type: CONSTANTS.DIGITAL_CORRESPONDANCE_TABLES_UPDATE_ERROR, payload: error };
}


/** DELETE */
export function deleteDigitalCorrespondanceTable(guid: string) {
    return { type: CONSTANTS.DIGITAL_CORRESPONDANCE_TABLE_DELETE, payload: guid };
}

export function deleteDigitalCorrespondanceTableSuccess(guid: string) {
    return { type: CONSTANTS.DIGITAL_CORRESPONDANCE_TABLE_DELETE_SUCCESS, payload: guid };
}

export function deleteDigitalCorrespondanceTableError(error: any) {
    return { type: CONSTANTS.DIGITAL_CORRESPONDANCE_TABLE_DELETE_ERROR, payload: error };
}

export function deleteDigitalCorrespondanceTables(guids: string[]) {
    return { type: CONSTANTS.DIGITAL_CORRESPONDANCE_TABLES_DELETE, payload: guids };
}

export function deleteDigitalCorrespondanceTablesSuccess(digitalCorrespondanceTables: DigitalCorrespondanceTable[]) {
    return { type: CONSTANTS.DIGITAL_CORRESPONDANCE_TABLES_DELETE_SUCCESS, payload: digitalCorrespondanceTables };
}

export function deleteDigitalCorrespondanceTablesError(error: any) {
    return { type: CONSTANTS.DIGITAL_CORRESPONDANCE_TABLES_DELETE_ERROR, payload: error };
}